/**
 * UI string dictionary for bilingual rendering.
 *
 * Usage:
 *   import { t } from '@/i18n/strings';
 *   t('cta_book_appointment', 'es'); // -> "Reservar Cita"
 *
 * Mexican-American Spanish (es-US) per FORTWORTHDENTAL_BILINGUAL_BRIEF.md.
 * Apply the dental glossary — never machine-translate generic dental terms.
 */

export const STRINGS = {
  // CTAs
  cta_book_appointment:   { en: 'Book Appointment',                 es: 'Reservar Cita' },
  cta_call_now:           { en: 'Call Now',                         es: 'Llamar Ahora' },
  cta_get_directions:     { en: 'Get Directions',                   es: 'Cómo Llegar' },
  cta_new_patients:       { en: 'New Patients Welcome',             es: 'Nuevos Pacientes Bienvenidos' },
  cta_learn_more:         { en: 'Learn More',                       es: 'Saber Más' },
  cta_request_appointment:{ en: 'Request Appointment',              es: 'Solicitar Cita' },
  cta_free_consultation:  { en: 'Free Consultation',                es: 'Consulta Gratis' },

  // Form labels
  form_name:              { en: 'Full name',                        es: 'Nombre completo' },
  form_email:             { en: 'Email address',                    es: 'Correo electrónico' },
  form_phone:             { en: 'Phone',                            es: 'Teléfono' },
  form_message:           { en: 'How can we help?',                 es: '¿En qué podemos ayudarte?' },
  form_insurance:         { en: 'Insurance provider (optional)',    es: 'Compañía de seguro (opcional)' },
  form_submit:            { en: 'Request Appointment',              es: 'Solicitar Cita' },
  form_submitting:        { en: 'Sending...',                       es: 'Enviando...' },

  // Validation
  validation_required:    { en: 'This field is required',           es: 'Este campo es obligatorio' },
  validation_email:       { en: 'Enter a valid email',              es: 'Ingresa un correo válido' },
  validation_phone:       { en: 'Enter a valid phone number',       es: 'Ingresa un teléfono válido' },

  // Toasts
  toast_success:          { en: "Thanks! We'll call you within 1 business day.",
                            es: "¡Gracias! Te llamaremos dentro de 1 día hábil." },
  toast_error:            { en: 'Something went wrong. Please try again.',
                            es: 'Algo salió mal. Inténtalo de nuevo.' },

  // Nav
  nav_home:               { en: 'Home',                             es: 'Inicio' },
  nav_services:           { en: 'Services',                         es: 'Servicios' },
  nav_about:              { en: 'About',                            es: 'Sobre Nosotros' },
  nav_contact:            { en: 'Contact',                          es: 'Contacto' },
  nav_blog:               { en: 'Blog',                             es: 'Blog' },
  nav_new_patients:       { en: 'New Patients',                     es: 'Nuevos Pacientes' },
  nav_specials:           { en: 'Specials',                         es: 'Promociones' },
  nav_testimonials:       { en: 'Testimonials',                     es: 'Testimonios' },

  // Trust / brand
  insurance_accepted:     { en: 'Insurance accepted',               es: 'Aceptamos seguro' },
  emergency_dental:       { en: 'Emergency dental care',            es: 'Emergencia dental' },
  walkins_welcome:        { en: 'Walk-ins welcome',                 es: 'Atendemos sin cita' },
  bilingual_staff:        { en: 'We speak Spanish',                 es: 'Hablamos Español' },
  five_star_reviews:      { en: '1,100+ five-star reviews',         es: 'Más de 1,100 reseñas de 5 estrellas' },

  // Exit popup
  popup_headline:         { en: 'Wait! Your smile deserves the best.',
                            es: '¡Espera! Tu sonrisa merece lo mejor.' },
  popup_subline:          { en: 'Book your first dental cleaning for just $49 ($150 value).',
                            es: 'Reserva tu primera limpieza dental por solo $49 (valor de $150).' },
  popup_cta:              { en: 'Book My Appointment',              es: 'Reservar Mi Cita' },
  popup_reassurance:      { en: 'No spam — only your appointment confirmation.',
                            es: 'Sin spam — solo confirmación de tu cita.' },

  // Lang toggle
  lang_to_es:             { en: 'Español',                          es: 'Español' },
  lang_to_en:             { en: 'English',                          es: 'English' },
};

export const t = (key, lang = 'en') => {
  const entry = STRINGS[key];
  if (!entry) return key;
  return entry[lang] || entry.en || key;
};

export default t;
